import { ChangeEvent } from 'react'
import { FormField } from '../../../../Components'
import { defineMessages, useIntl } from 'react-intl'

export const MSG = defineMessages({
  label: {
    id: 'BombBomb.form.subject.label',
    defaultMessage: 'Subject'
  },
  placeholder: {
    id: 'BombBomb.form.subject.placeholder',
    defaultMessage: 'Subject'
  }
})

export interface BombBombSendFormSubjectProps {
  subject: string
  setSubject(subject: string): void
}

export const BombBombSendFormSubject = ({ subject, setSubject }: BombBombSendFormSubjectProps) => {
  const intl = useIntl()

  return (
    // @ts-ignore
    <FormField
      required
      value={subject}
      name='recorder-email-subject'
      placeholder={intl.formatMessage(MSG.placeholder)}
      onChange={(e: ChangeEvent<HTMLInputElement>) => setSubject(e.target.value)}
    >
      {intl.formatMessage(MSG.label)}
    </FormField>
  )
}
